/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum OrderQuoteSideKindBuy {
    BUY = 'buy',
}
